/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import DiaglabSampleItem from './diaglab-sample-item';
import DiaglabSampleItemDetail from './diaglab-sample-item-detail';
import DiaglabSampleItemUpdate from './diaglab-sample-item-update';
import DiaglabSampleItemDeleteDialog from './diaglab-sample-item-delete-dialog';

const DiaglabSampleItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<DiaglabSampleItem />} />
    <Route path="new" element={<DiaglabSampleItemUpdate />} />
    <Route path=":id">
      <Route index element={<DiaglabSampleItemDetail />} />
      <Route path="edit" element={<DiaglabSampleItemUpdate />} />
      <Route path="delete" element={<DiaglabSampleItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default DiaglabSampleItemRoutes;
